// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  companyName: 'GSDP',

  // postapiUrl: 'http://postapi.ssw.vn/api',
  // coreapiUrl: 'http://coreapi.ssw.vn/api',
  // crmApiUrl: 'http://crmapi.ssw.vn/api',
  // apiUrl: 'http://cusapi.ssw.vn/api',
  // apiUrl: 'http://localhost:55409/api',

  apiUrl:     'https://cusapitest.gsdp.vn/api',
  coreapiUrl: 'https://coreapitest.gsdp.vn/api',
  postapiUrl: 'https://postapitest.gsdp.vn/api',
  crmApiUrl:  'https://crmapitest.gsdp.vn/api',


  // apiUrl:     'https://cusapi.gsdp.vn/api',
  // crmApiUrl:  'https://crmapi.gsdp.vn/api',
  // coreapiUrl: 'https://coreapi.gsdp.vn/api',
  // postapiUrl: 'https://postapi.gsdp.vn/api',
  
  formatDateTimeTable: '',
  formatDateTable: '',
  gMapKey: ''
};
environment.formatDateTimeTable = 'yyyy/MM/dd HH:mm';
environment.formatDateTable = 'yyyy/MM/dd';
environment.gMapKey = 'AIzaSyC4fCjR3_dwicONd_d5gvcjnrymFLOn3ng';

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
